'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = CenteredLanding;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SpruceClassName = require('stampy/lib/util/SpruceClassName');

var _SpruceClassName2 = _interopRequireDefault(_SpruceClassName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CenteredLanding(props) {
    var className = props.className,
        modifier = props.modifier,
        _props$spruceName = props.spruceName,
        name = _props$spruceName === undefined ? 'CenteredLanding' : _props$spruceName,
        top = props.top,
        bottom = props.bottom,
        otherProps = (0, _objectWithoutProperties3.default)(props, ['className', 'modifier', 'spruceName', 'top', 'bottom']);


    var parentClassName = (0, _SpruceClassName2.default)({ className: className, modifier: modifier, name: name });

    return _react2.default.createElement(
        'div',
        (0, _extends3.default)({ className: parentClassName }, otherProps),
        _react2.default.createElement(
            'div',
            { className: name + '_topContainer' },
            _react2.default.createElement(
                'div',
                { className: name + '_top' },
                top()
            )
        ),
        _react2.default.createElement(
            'div',
            { className: name + '_bottom' },
            bottom()
        )
    );
}


//////////////////
// WEBPACK FOOTER
// ./~/dcme-style/lib/shape/CenteredLanding.js
// module id = 97
// module chunks = 35783957827783 114276838955818 162898551421021